import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCaja } from '../contexts/CajaContext';
import { getApiUrl } from '../config/apiConfig';
import clientPrinterService from '../services/clientPrinterService';
import './Pedidos.css';

const PedidosModule = () => {
  const {mesaId} = useParams();
  console.log("🚀 ~ PedidosModule ~ mesaId:", mesaId)
  const navigate = useNavigate();
  const { auth } = useAuth();
  const { caja } = useCaja();
  
  const [mesa, setMesa] = useState(null);
  const [productos, setProductos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [pedidosActivos, setPedidosActivos] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('todas');
  const [busquedaProducto, setBusquedaProducto] = useState('');
  const [nuevoPedido, setNuevoPedido] = useState([]);
  const [observaciones, setObservaciones] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [vistaActual, setVistaActual] = useState('nuevo');
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
  // Nuevo estado para el mensaje de confirmación
  const [mensajeAccion, setMensajeAccion] = useState('');
  const [creandoPedido, setCreandoPedido] = useState(false);

  // Selector de barra/cocina
  const [barras, setBarras] = useState([]);
  const [barraSeleccionada, setBarraSeleccionada] = useState(null);
  const [mostrarModalBarra, setMostrarModalBarra] = useState(false);

  // Barra asignada al MOZO obtenida en tiempo real desde la DB (evita JWT desactualizado)
  const [barraAsignadaDB, setBarraAsignadaDB] = useState(auth?.user?.id_barra_asignada || null);

  // Cargar barras/cocinas disponibles
  useEffect(() => {
    const fetchBarras = async () => {
      try {
        const res = await fetch(getApiUrl('/barras'), {
          headers: { 'Authorization': `Bearer ${auth?.token}` }
        });
        if (res.ok) setBarras(await res.json());
      } catch {}
    };
    if (auth?.token) fetchBarras();
  }, [auth?.token]);

  // Fetch real-time de asignaciones del MOZO/CAJERO para evitar JWT desactualizado
  useEffect(() => {
    if (!auth?.token || !['MOZO', 'CAJERO'].includes(auth?.user?.rol)) return;
    fetch(getApiUrl('/usuarios-admin/mis-asignaciones'), {
      headers: { 'Authorization': `Bearer ${auth.token}` }
    })
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (data) setBarraAsignadaDB(data.id_barra_asignada || null); })
      .catch(() => {});
  }, [auth?.token]);

  useEffect(() => {

    console.log(mesaId)
    const fetchInicial = async () => {
      try {
        setLoading(true);
        
        // Obtener información de la mesa
        if (mesaId) {
          const responseMesa = await fetch(getApiUrl(`/mesas/${mesaId}`), {
            headers: {
              'Authorization': `Bearer ${auth?.token}`
            }
          });
          
          if (!responseMesa.ok) {
            throw new Error('Error al cargar información de la mesa');
          }
          
          const dataMesa = await responseMesa.json();
          // El endpoint /mesas/:id devuelve { mesa: {...}, pedidos: [...] }
          // Extraer el sub-objeto mesa para que mesa?.numero y mesa?.piso funcionen correctamente
          setMesa(dataMesa.mesa || dataMesa);
        }
        
        // Obtener productos
        const responseProductos = await fetch(getApiUrl('/productos'), {
          headers: {
            'Authorization': `Bearer ${auth?.token}`
          }
        });

        if (!responseProductos.ok) {
          throw new Error('Error al cargar productos');
        }

        const dataProductos = await responseProductos.json();
        // Asegurarse que todos los precios y costos sean números
        const productosNormalizados = dataProductos.map(p => ({
          ...p,
          precio: typeof p.precio === 'string' ? parseFloat(p.precio) : p.precio,
          costo: typeof p.costo === 'string' ? parseFloat(p.costo) : p.costo
        }));
        setProductos(productosNormalizados);
        
        // Extraer categorías únicas
        const categoriasUnicas = [...new Set(dataProductos.map(p => p.categoria))];
        setCategorias(categoriasUnicas);
        
        // Obtener pedidos activos de la mesa
        if (mesaId) {
          // Cambiado para usar el endpoint correcto - no existe /pedidos/mesa/ en el backend
          const responsePedidos = await fetch(getApiUrl(`/pedidos?estado=pendiente`), {
            headers: {
              'Authorization': `Bearer ${auth?.token}`
            }
          });
          
          if (!responsePedidos.ok) {
            throw new Error('Error al cargar pedidos');
          }
          
          const dataPedidos = await responsePedidos.json();
          // Filtrar pedidos por mesa
          const pedidosMesa = dataPedidos.filter(pedido => pedido.id_mesa === parseInt(mesaId));
          setPedidosActivos(pedidosMesa);
        }
        
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };
    
    fetchInicial();
  }, [mesaId]);

  const filtrarProductos = () => {
    let resultado = productos;
    if (categoriaSeleccionada !== 'todas') {
      resultado = resultado.filter(p => p.categoria === categoriaSeleccionada);
    }
    if (busquedaProducto.trim()) {
      resultado = resultado.filter(p =>
        p.nombre.toLowerCase().includes(busquedaProducto.toLowerCase())
      );
    }
    return resultado;
  };

  const agregarProductoAPedido = (producto) => {
    // Verificar si el producto ya está en el pedido
    const productoExistente = nuevoPedido.find(item => item.id === producto.id);
    
    if (productoExistente) {
      // Incrementar cantidad
      setNuevoPedido(nuevoPedido.map(item => 
        item.id === producto.id ? { ...item, cantidad: item.cantidad + 1 } : item
      ));
    } else {
      // Agregar nuevo producto al pedido
      setNuevoPedido([...nuevoPedido, { ...producto, cantidad: 1 }]);
    }
  };

  const quitarProductoDePedido = (productoId) => {
    setNuevoPedido(nuevoPedido.filter(item => item.id !== productoId));
  };

  const actualizarCantidadProducto = (productoId, nuevaCantidad) => {
    if (nuevaCantidad <= 0) {
      quitarProductoDePedido(productoId);
      return;
    }
    
    setNuevoPedido(nuevoPedido.map(item => 
      item.id === productoId ? { ...item, cantidad: nuevaCantidad } : item
    ));
  };

  const calcularTotal = () => {
    return nuevoPedido.reduce((total, item) => total + (item.precio * item.cantidad), 0).toFixed(2);
  };

  const crearPedido = async (id_barra = null) => {
    if (nuevoPedido.length === 0) {
      setError('No hay productos en el pedido');
      return;
    }

    setMostrarModalBarra(false);
    setCreandoPedido(true);

    try {
      // Adaptado para coincidir con la estructura esperada por el backend
      const productos = nuevoPedido.map(item => ({
        id_producto: item.id,
        cantidad: item.cantidad,
        notas: '' // Este campo existe en el backend
      }));

      const pedidoData = {
        id_mesa: parseInt(mesaId),
        productos: productos,
        observaciones: observaciones,
        id_barra: id_barra || null,
      };
      
      console.log('Enviando datos al servidor:', pedidoData);
      console.log('URL:', getApiUrl('/pedidos'));
      console.log('Token:', auth?.token);
      
      const response = await fetch(getApiUrl('/pedidos'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.token}`
        },
        body: JSON.stringify(pedidoData)
      });
      
      // Verificar la respuesta antes de intentar parsearla
      if (!response.ok) {
        // Si la respuesta no es JSON, obtén el texto
        const text = await response.text();
        console.error('Error response:', text);
        throw new Error(`Error ${response.status}: ${text.substring(0, 100)}...`);
      }
      
      const responseData = await response.json();
      console.log('Respuesta del servidor:', responseData);
      
      // Auto-imprimir comanda en cliente con Motor de Impresión Cliente Universal
      try {
        const pisoMesa = mesa?.piso ?? mesa?.numero_piso ?? mesa?.piso_mesa ?? auth?.user?.piso_asignado ?? 1;
        const mesaNumero = mesa?.numero ?? mesa?.numero_mesa;
        const mesaFormateada = mesaNumero 
          ? (String(mesaNumero).toLowerCase().startsWith('mesa') ? String(mesaNumero) : `Mesa ${mesaNumero}`)
          : (parseInt(mesaId) === 910100 ? 'DIRECTO' : `Mesa ${mesaId}`);

        const datosComanda = {
          ordenId: responseData.id,
          id: responseData.id,
          mesa: mesaFormateada,
          piso: pisoMesa,
          mozo: auth?.user?.nombre || auth?.user?.usuario || 'Mozo',
          fecha: new Date().toLocaleDateString('es-PE'),
          hora: new Date().toLocaleTimeString('es-PE', { hour: '2-digit', minute: '2-digit' }),
          items: nuevoPedido.map(item => ({
            nombre: item.nombre,
            cantidad: item.cantidad,
            notas: item.notas || '',
            categoria: item.categoria_nombre || item.categoria || item.nombre_categoria || item.tiempo || 'GENERAL'
          })),
          notaGeneral: observaciones || ''
        };

        await clientPrinterService.imprimirComandaCliente(datosComanda, 'NUEVA');
      } catch (printErr) {
        console.error('Error al enviar comanda a la impresora:', printErr);
      }

      // Mostrar mensaje de éxito
      setMensajeAccion('¡Pedido creado con éxito!');
      
      // Limpiar el pedido
      setNuevoPedido([]);
      setObservaciones('');
      
      setMensajeAccion('');
      navigate(`/mesa/${mesaId}/pedidos`);
      
    } catch (err) {
      console.error('Error completo:', err);
      setError(err.message);
    } finally {
      setCreandoPedido(false);
    }
  };

  const actualizarEstadoPedido = async (pedidoId, nuevoEstado) => {
    try {
      // Se cambia PATCH a PUT para coincidir con el backend
      const response = await fetch(getApiUrl(`/pedidos/${pedidoId}`), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth?.token}`
        },
        body: JSON.stringify({ estado: nuevoEstado })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al actualizar el estado del pedido');
      }
      
      // Actualizar estado local
      setPedidosActivos(pedidosActivos.map(pedido => 
        pedido.id === pedidoId ? { ...pedido, estado: nuevoEstado } : pedido
      ));
      
      // Si estamos viendo el detalle del pedido que se actualiza, actualizarlo también
      if (pedidoSeleccionado && pedidoSeleccionado.id === pedidoId) {
        setPedidoSeleccionado({ ...pedidoSeleccionado, estado: nuevoEstado });
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const verDetallePedido = async (pedidoId) => {
    try {
      const response = await fetch(getApiUrl(`/pedidos/${pedidoId}`), {
        headers: {
          'Authorization': `Bearer ${auth?.token}`
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error al cargar detalle del pedido');
      }
      
      const data = await response.json();
      setPedidoSeleccionado(data);
      setVistaActual('detalle');
    } catch (err) {
      setError(err.message);
    }
  };

  const formatearTiempo = (timestamp) => {
    const fecha = new Date(timestamp);
    return fecha.toLocaleString();
  };

  const calcularTiempoTranscurrido = (timestamp) => {
    const fecha = new Date(timestamp);
    const ahora = new Date();
    const diferencia = Math.floor((ahora - fecha) / 1000 / 60); // en minutos
    
    if (diferencia < 60) {
      return `${diferencia} min`;
    } else {
      const horas = Math.floor(diferencia / 60);
      const minutos = diferencia % 60;
      return `${horas}h ${minutos}m`;
    }
  };

  const getEstadoClass = (estado) => {
    switch (estado) {
      case 'pendiente': return 'estado-pendiente';
      case 'en_prep': return 'estado-preparacion';
      case 'listo': return 'estado-listo';
      case 'entregado': return 'estado-entregado';
      case 'cancelado': return 'estado-cancelado';
      case 'pagado': return 'estado-pagado'; // Agregado para coincidir con el backend
      default: return '';
    }
  };

  // Mapeo de roles de backend a frontend
  const mapearRol = (rol) => {
    switch (rol) {
      case 'MOZO': return 'mesero';
      case 'ENCARGADO': return 'administrador';
      default: return rol.toLowerCase();
    }
  };

  // Función para mapear el rol en la comparación
  const checkUserRole = (allowedRoles) => {
    const mappedRole = mapearRol(auth?.rol);
    return allowedRoles.includes(mappedRole);
  };

  if (caja.loading) return <div className="loading">Verificando estado de caja...</div>;

  if (!caja.estaAbierta) return (
    <div className="caja-cerrada-aviso">
      <h3>⚠️ Caja no aperturada</h3>
      <p>No se pueden crear pedidos de mesa sin abrir la caja primero.</p>
      <button className="btn-ir-caja" onClick={() => navigate('/caja')}>Ir a Caja</button>
    </div>
  );

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error">Error: {error}</div>
        <button 
          onClick={() => {
            setError(null);
            navigate('/mesas');
          }}
          className="btn-volver"
        >
          Volver a Mesas
        </button>
      </div>
    );
  }

  // Vista de crear nuevo pedido
  if (vistaActual === 'nuevo') {
    return (
      <div className="pedidos-container">
        <div className="pedidos-header">
          <h2>Nuevo Pedido - Mesa {mesa?.numero}</h2>
          <button 
            className="btn-volver"
            onClick={() => navigate(`/mesa/${mesaId}/pedidos`)}
          >
            Cancelar
          </button>
        </div>

        {mensajeAccion && (
          <div className="mensaje-confirmacion">
            {mensajeAccion}
          </div>
        )}

        <div className="nuevo-pedido-grid">
          <div className="productos-section">
            <div className="buscador-productos">
              <input
                type="text"
                placeholder="Buscar producto..."
                value={busquedaProducto}
                onChange={(e) => setBusquedaProducto(e.target.value)}
                className="input-busqueda-producto"
              />
              {busquedaProducto && (
                <button className="btn-limpiar-busqueda" onClick={() => setBusquedaProducto('')}>×</button>
              )}
            </div>
            <div className="categorias-tabs">
              <button 
                className={categoriaSeleccionada === 'todas' ? 'active' : ''}
                onClick={() => setCategoriaSeleccionada('todas')}
              >
                Todas
              </button>
              {categorias.map(categoria => (
                <button 
                  key={categoria}
                  className={categoriaSeleccionada === categoria ? 'active' : ''}
                  onClick={() => setCategoriaSeleccionada(categoria)}
                >
                  {categoria}
                </button>
              ))}
            </div>

            <div className="productos-grid">
              {filtrarProductos().map(producto => (
                <div 
                  key={producto.id} 
                  className="producto-card"
                  onClick={() => agregarProductoAPedido(producto)}
                >
                  <div className="producto-nombre">{producto.nombre}</div>
                  <div className="producto-precio">S/. {producto.precio.toFixed(2)}</div>
                  <div className="producto-stock">Stock: {producto.stock_actual} {producto.unidad_medida}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="resumen-pedido">
            <h3>Resumen del Pedido</h3>
            
            {nuevoPedido.length === 0 ? (
              <div className="pedido-vacio">
                <p>Selecciona productos para agregar al pedido</p>
              </div>
            ) : (
              <>
                <div className="items-pedido">
                  {nuevoPedido.map(item => (
                    <div key={item.id} className="item-pedido">
                      <div className="item-info">
                        <div className="item-nombre">{item.nombre}</div>
                        <div className="item-precio">S/. {item.precio.toFixed(2)}</div>
                      </div>
                      <div className="item-controles">
                        <button 
                          className="btn-cantidad"
                          onClick={() => actualizarCantidadProducto(item.id, item.cantidad - 1)}
                        >
                          -
                        </button>
                        <span className="item-cantidad">{item.cantidad}</span>
                        <button 
                          className="btn-cantidad"
                          onClick={() => actualizarCantidadProducto(item.id, item.cantidad + 1)}
                        >
                          +
                        </button>
                        <button 
                          className="btn-eliminar"
                          onClick={() => quitarProductoDePedido(item.id)}
                        >
                          ×
                        </button>
                      </div>
                      <div className="item-subtotal">
                        S/. {(item.precio * item.cantidad).toFixed(2)}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="observaciones">
                  <label htmlFor="observaciones">Observaciones del pedido:</label>
                  <textarea
                    id="observaciones"
                    value={observaciones}
                    onChange={(e) => setObservaciones(e.target.value)}
                    placeholder="Agregar indicaciones especiales..."
                    rows={3}
                  />
                </div>

                <div className="total-pedido">
                  <div className="label">Total:</div>
                  <div className="monto">S/. {calcularTotal()}</div>
                </div>

                <button
                  className="btn-crear-pedido"
                  disabled={creandoPedido || nuevoPedido.length === 0}
                  onClick={() => {
                    // Si el MOZO/CAJERO tiene barra asignada (leída desde DB), enviar directo sin modal
                    const barraAsig = ['MOZO', 'CAJERO'].includes(auth?.user?.rol) ? barraAsignadaDB : null;
                    if (barraAsig) {
                      crearPedido(barraAsig);
                    } else if (barras.length > 0) {
                      setBarraSeleccionada(null);
                      setMostrarModalBarra(true);
                    } else {
                      crearPedido(null);
                    }
                  }}
                >
                  {creandoPedido ? '⏳ Imprimiendo comanda...' : 'Crear Pedido'}
                </button>

                {/* Modal selector de barra/cocina */}
                {mostrarModalBarra && (
                  <div style={{
                    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.65)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
                  }}>
                    <div style={{
                      background: '#1e293b', borderRadius: 12, padding: '1.5rem',
                      minWidth: 300, maxWidth: 420, boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
                    }}>
                      <h3 style={{ color: '#f1f5f9', marginBottom: '1rem', fontSize: '1.1rem' }}>
                        ¿A qué barra/cocina va este pedido?
                      </h3>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1.25rem' }}>
                        {barras.map(b => (
                          <button
                            key={b.id}
                            onClick={() => setBarraSeleccionada(b.id)}
                            style={{
                              padding: '0.5rem 1rem', borderRadius: 6, border: '2px solid',
                              borderColor: barraSeleccionada === b.id ? '#3b82f6' : '#475569',
                              background: barraSeleccionada === b.id ? '#1d4ed8' : '#0f172a',
                              color: '#f1f5f9', cursor: 'pointer', fontWeight: barraSeleccionada === b.id ? 700 : 400,
                            }}
                          >
                            {b.nombre}
                          </button>
                        ))}
                      </div>
                      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
                        <button
                          onClick={() => setMostrarModalBarra(false)}
                          style={{ padding: '0.5rem 1rem', borderRadius: 6, border: 'none', background: '#334155', color: '#f1f5f9', cursor: 'pointer' }}
                        >
                          Cancelar
                        </button>
                        <button
                          onClick={() => crearPedido(barraSeleccionada)}
                          disabled={!barraSeleccionada}
                          style={{
                            padding: '0.5rem 1.25rem', borderRadius: 6, border: 'none',
                            background: barraSeleccionada ? '#3b82f6' : '#334155',
                            color: '#fff', fontWeight: 600,
                            cursor: barraSeleccionada ? 'pointer' : 'not-allowed',
                          }}
                        >
                          Confirmar
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  return <div>Vista no definida</div>;
};

export default PedidosModule;